import React, { useState, useEffect, createContext } from "react";
import { useGlobalState } from "../state";
import Paper from '@mui/material/Paper';
import axios from "axios";
import { DataGrid} from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Input from '@mui/material/Input';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import { NumericFormat } from 'react-number-format';
import { Backdrop, CircularProgress } from '@mui/material'
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import EditButtons from './EditButtons'
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { set } from "mongoose";

const paginationModel = { page: 0, pageSize: 5 };

const TextMaskCustom = React.forwardRef(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(#00) 000-0000"
        definitions={{
          '#': /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  });
  
  TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };
  
  const NumericFormatCustom = React.forwardRef(
    function NumericFormatCustom(props, ref) {
      const { onChange, ...other } = props;
  
      return (
        <NumericFormat
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
          thousandSeparator
          valueIsNumericString
          prefix="$"
        />
      );
    },
  );
  
  NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

export default function BlockedNumberTable() {

const [open, setOpen] = React.useState(false);
const [secondaryModalOpen, setSecondaryModalOpen] = React.useState(false);
const [blocked_number_input, set_blocked_number_input] = useGlobalState('blocked_number_input')
const [isLoading, setIsLoading] = useState(false)
const [isDisabled, setIsDisabled] = useState(true)
const [editMode, setEditMode] = useGlobalState('editMode');
const [dataTableName, setDataTableName] = useGlobalState('dataTableName');
const [rows, setRows] = React.useState([]);
const [alertOpen, setAlertOpen] = React.useState(false);
const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
const [getDataTableErrorAlertOpen, setGetDataTableErrorAlertOpen] = React.useState(false);
const [submitDisable, setSubmitDisable] = React.useState(true);
const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
const [rowIdToDelete, setRowIdToDelete] = useState(null);
const [deleteRowAlertOpen, setDeleteRowAlertOpen] = useState(false);
const columns = [{
  field: 'blocked_num',
  headerName: 'Blocked Numbers',
  width: 800
},
{
  field: 'Name of Submitter',
  headerName: 'Submitter Information',
  width: 150
},
{
  field: 'Date Submitted',
  headerName: 'Date Submitted',
  width: 150
},
{
  field: 'actions',
  headerName: 'Actions',
  width: 100,
  sortable: false,
  disableColumnMenu: true,
  renderCell: (params) => (
    <IconButton
      onClick={() => modalDeleteOpen(params.row.blocked_num)}
      disabled={!editMode}
      color="error"
      size="small"
    >
      <DeleteIcon />
    </IconButton>
  ),
}];

useEffect(() => {
  if (editMode) {
    setIsDisabled(false)
  }
  if (!editMode) {
    setIsDisabled(true)
  }
})

useEffect(() => {
  if (blocked_number_input.length > 13) {
    setSubmitDisable(false)
  } else if (blocked_number_input.length < 14) {
    setSubmitDisable(true)
  }
})

useEffect(() => {
  establishDataTableName()
})

// Add useEffect to load data when dataTableName changes
useEffect(() => {
  if (dataTableName) {
    getDataTableData()
  }
}, [dataTableName])

const handleClickOpen = () => {
  setOpen(true);
};

const handleClose = () => {
  setOpen(false);
  set_blocked_number_input('')
};

const handleSecondaryClickOpen = () => {
  setSecondaryModalOpen(true);
};

const handleSecondaryClose = () => {
  setSecondaryModalOpen(false);
};

const handleCloseAll = () => {
  setOpen(false);
  set_blocked_number_input('')
  setSecondaryModalOpen(false);
};

const handleAlertClose = (event, reason) => {
  if (reason === 'clickaway') {
    setAlertOpen(false)
    setErrorAlertOpen(false)
    setGetDataTableErrorAlertOpen(false);
    return;
  }
}

const modalDeleteOpen = (rowId) => {
  setRowIdToDelete(rowId);
  setDeleteModalOpen(true);
}

const handleDeleteModalClose = () => {
  setDeleteModalOpen(false);
}

const closeGetDataTableErrorAlertOpen = () => {
  setGetDataTableErrorAlertOpen(false);
  getDataTableData()
};

const handleDeleteRowAlertClose = () => {
  setDeleteRowAlertOpen(false);
  getDataTableData();
}

const closeDeleteRowAlertOpen = () => {
  setDeleteRowAlertOpen(false);
  getDataTableData();
};

const handleChange = (event) => {
  set_blocked_number_input(event.target.value)
};

const establishDataTableName = async () => {
  if (window.location.pathname === '/configuration-cr') {
    setDataTableName("CR_Blocked_Numbers");
  }
  if (window.location.pathname === '/configuration-ao') {
    setDataTableName("AO_BlockedNumber");
  }
  if (window.location.pathname === '/configuration-as') {
    setDataTableName("AS_BlockedNumbers");
  }
  if (window.location.pathname === '/configuration-cbo') {
    setDataTableName("CBO_BlockedNumbers");
  }
}

const getDataTableData = async () => {
  try {
    setIsLoading(true); // Add loading state
    
    // Validate that dataTableName is set
    if (!dataTableName) {
      console.error("(getDataTableData) - dataTableName is not set");
      setGetDataTableErrorAlertOpen(true);
      return;
    }

    let functionArray = []
    let params = {
      dataTableName: dataTableName
    }
    
    let getTableData = await axios.get('/api/az_func_genesys_data_table', {params});
    console.log("(getDataTableData) Full response:", getTableData);
    
    // Validate response structure
    if (!getTableData?.data?.result?.result) {
      console.error("(getDataTableData) - Invalid response structure:", getTableData?.data);
      setGetDataTableErrorAlertOpen(true);
      return;
    }

    // Check if result is an array or object
    const resultData = getTableData.data.result.result;
    
    if (Array.isArray(resultData)) {
      // Handle array format
      resultData.forEach((item, index) => {
        let newTableRow = {
          'id': index.toString(), // Use string ID instead of array
          'blocked_num': item.key || '',
          'Name of Submitter': item['Name of Submitter'] || 'N/A',
          'Date Submitted': item['Date Submitted'] || 'N/A'
        }
        functionArray.push(newTableRow)
      });
    } else if (typeof resultData === 'object') {
      // Handle object format (current implementation)
      let index = 0;
      for (const i in resultData) {
        let newTableRow = {
          'id': index.toString(), // Use sequential index as string
          'blocked_num': resultData[i].key || '',
          'Name of Submitter': resultData[i]['Name of Submitter'] || 'N/A',
          'Date Submitted': resultData[i]['Date Submitted'] || 'N/A'
        }
        functionArray.push(newTableRow)
        index++;
      }
    }
    
    setRows(functionArray)
    console.log("(getDataTableData) Successfully loaded", functionArray.length, "rows");
  } catch (err) {
    console.error("(getDataTableData) - Error details:", {
      message: err.message,
      status: err.response?.status,
      statusText: err.response?.statusText,
      data: err.response?.data
    });
    setGetDataTableErrorAlertOpen(true)
  } finally {
    setIsLoading(false); // Always clear loading state
  }
}

const submitPhoneNumber = async () => {
  try {
    setIsLoading(true)
    let new_blocked_number_input = blocked_number_input.replace("(", "").replace(")", "").replace("-", "").replace(" ", "");
    let current_user = window.localStorage.getItem('username')
    let submission_date_time = new Date().toLocaleString()
    let params = {
      dataTableName: dataTableName,
      dataTableRow: {
        "key": new_blocked_number_input,
        "Name of Submitter": current_user,
        "Date Submitted": submission_date_time
      }
    }
    let submitNumber = await axios.post('/api/az_func_genesys_data_table', {params});
    if (!submitNumber?.data) {
      handleCloseAll()
      setIsLoading(false)
      setEditMode(false)
      setErrorAlertOpen(true)
      console.log("(submitPhoneNumber) - There was an error submitting the phone number to Genesys.")
    }
    handleCloseAll()
    setIsLoading(false)
    setEditMode(false)
    setAlertOpen(true)
    getDataTableData()
  } catch (err) {
    console.log("(submitPhoneNumber) - There was an error submitting the phone number to Genesys.")
  }
}

const deleteDataTableRow = async (rowId) => {
  try {
    setIsLoading(true)
    let params = {
      dataTableName: dataTableName,
      rowId: rowId,
      operation: 'delete'
    }
    // Use the same format as POST request for consistency
    let deleteRow = await axios.post('/api/az_func_genesys_data_table', {params});
    if (!deleteRow?.data?.success) {
      setIsLoading(false)
      setDeleteRowAlertOpen(true)
      console.log("(deleteDataTableRow) - There was an error deleting the phone number from Genesys.")
    } else {
      setIsLoading(false)
      setDeleteModalOpen(false)
      setAlertOpen(true)
      getDataTableData()
    }
  } catch (err) {
    console.log("(deleteDataTableRow) - There was an error deleting the phone number from Genesys.")
    setIsLoading(false)
    setErrorAlertOpen(true)
  }
}

  return (
  <Box>
    <Box >
      <EditButtons sx={{ marginTop: '-3%' }} />
      <Toolbar />
      <Accordion sx={{ width: "100%" }} onClick={getDataTableData}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon onClick={getDataTableData} />}
          aria-controls="panel1a-content"
          id="panel1a-header"

        >
          <Typography className="uiSubHeaderFont" id="accordionLabel">
            Blocked Numbers
          </Typography>
          <Tooltip
            title="Blocked numbers are phone numbers that have been restricted from connecting with contact center agents, preventing any inbound communication attempts from those numbers. "
            sx={{ paddingTop: "0", color: '#febd12' }}
          >
            <IconButton>
              <HelpIcon />
            </IconButton>
          </Tooltip>
        </AccordionSummary>
        <AccordionDetails sx={{ width: "100%" }}>
          <Button variant="contained" disabled={isDisabled} onClick={handleClickOpen} sx={{ marginBottom: '2%' }} endIcon={<AddIcon />}>
            Add  Number
          </Button>
          <Paper sx={{ height: 350, width: '100%' }}>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10]}
              sx={{ border: 0 }}
            />
          </Paper>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>Add Phone Number to Blocked List</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please enter the 10 digit phone number that you would like to have added to the blocked number list.
              </DialogContentText>
              <Input
                value={blocked_number_input}
                onChange={handleChange}
                name="textmask"
                id="formatted-text-mask-input"
                inputComponent={TextMaskCustom}
                sx={{ width: '100%' }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button type="submit" disabled={submitDisable} onClick={handleSecondaryClickOpen}>Submit</Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={secondaryModalOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Are you sure you want to submit this number? :
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {blocked_number_input}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseAll}>Cancel</Button>
              <Button onClick={handleSecondaryClose}>Return & Edit</Button>
              <Button onClick={submitPhoneNumber} autoFocus> Submit </Button>
            </DialogActions>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Dialog>
          <Dialog
            open={deleteModalOpen}
            onClose={handleDeleteModalClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>Are you sure you would like to remove {rowIdToDelete} from the blocked number list?</DialogTitle>
            <DialogContent>
              <DialogContentText>
                This can only be undone by resubmitting {rowIdToDelete} again.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteModalClose}>Cancel</Button>
              <Button type="submit"onClick={() => deleteDataTableRow(rowIdToDelete)}>Delete</Button>
            </DialogActions>
          </Dialog>          
        </AccordionDetails>
      </Accordion>
      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleAlertClose} sx={{ width: '97%' }}>
        <Alert onClose={handleAlertClose} variant="filled" severity="success" sx={{ width: '100%' }}>
          Operation has been completed succesfully.
        </Alert>
      </Snackbar>
      <Snackbar open={errorAlertOpen} autoHideDuration={6000} onClose={handleAlertClose} sx={{ width: '97%' }}>
        <Alert onClose={handleAlertClose} variant="filled" severity="error" sx={{ width: '100%' }}>
          There Was An Issue Adding Your Number To The Blocked List.
        </Alert>
      </Snackbar>
      <Snackbar open={getDataTableErrorAlertOpen} autoHideDuration={6000} onClose={handleAlertClose} sx={{ width: '97%' }}>
        <Alert onClose={handleAlertClose} variant="filled" severity="error" sx={{ width: '100%' }} action={
          <Button color="inherit" size="small" onClick={closeGetDataTableErrorAlertOpen}>
            RETRY
          </Button>
        }>
          Error occurred getting table data, click RETRY to try again.
        </Alert>
      </Snackbar>
      <Snackbar open={deleteRowAlertOpen} autoHideDuration={6000} onClose={handleDeleteRowAlertClose} sx={{ width: '97%' }}>
        <Alert onClose={handleDeleteRowAlertClose} variant="filled" severity="error" sx={{ width: '100%' }} action={
          <Button color="inherit" size="small" onClick={closeDeleteRowAlertOpen}>
            RETRY
          </Button>
        }>
          An error occurred when trying to delete {rowIdToDelete}. Please Try again. 
        </Alert>
      </Snackbar>      
    </Box>
  </Box> 
  );
}
